<c-full-page-layout [hasFooter]="true">
  <div full-page-header>
    <div class="sign-document-page__header">
      <div class="sign-document-page__header-side">
        @if (!isFirst() || reviewMode) {
          <c-button
            type="secondary"
            [iconOnly]="true"
            [icon]="backIcon"
            [ariaLabel]="'common.back' | transloco"
            (action)="back()" />
        }
      </div>

      <h1 class="sign-document-page__title">{{ title() }}</h1>

      <div class="sign-document-page__header-side sign-document-page__header-side--end">
        <c-button
          type="secondary"
          [iconOnly]="true"
          [icon]="closeIcon"
          [ariaLabel]="'common.close' | transloco"
          (action)="close()" />
      </div>
    </div>
  </div>

  <div full-page-content>
    <div class="sign-document-page__content">
      <div class="sign-document-page__document">
        @if (active()) {
          @if (preview(); as file) {
            <c-pdf-view [file]="file" />
          } @else {
            <c-document-skeleton />
          }
        }
      </div>
    </div>
  </div>

  <div full-page-footer>
    <div class="sign-document-page__footer">
      <c-checkbox
        [formControl]="agreeControl"
        [label]="'my-documents.sign-batch.check' | transloco"
        [showError]="false" />

      @if (reviewMode) {
        <c-button
          iconPosition="start"
          [icon]="backIcon"
          (action)="back()">
          {{ 'my-documents.sign-batch.back-to-overview' | transloco }}
        </c-button>
      } @else {
        <c-button
          iconPosition="end"
          [icon]="nextIcon"
          (action)="next()">
          {{ 'my-documents.sign-batch.next' | transloco }}
        </c-button>
      }
    </div>
  </div>
</c-full-page-layout>
